module.exports = __webpack_public_path__ + "static/media/square-region.33bdbd73.jpg";